import React from 'react'

import { SignUpSignInModal } from 'components/SignUpSignInModal/SignUpSignInModal'

const SignInUpNav = () => {
  const [open, setOpen] = React.useState(false)
  const openModal = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <SignUpSignInModal open={open} handleClose={handleClose} />
      <span onClick={openModal} className="action__text">
        Sign In
      </span>
    </>
  )
}

export default SignInUpNav
